<template>
  <div class="home">
    <b-container>
      <b-row class="bg-dkblue header">
      </b-row>
    </b-container>

    <img class="logo-welcome" id="logo" alt="logo" src="../assets/logos/mdcai_logo_white_v1.svg"><br />


Registration is restricted to white-listed users only.<br />
Please enter your e-mail address to continue.<br /><br />

<b-container>

  <validation-observer ref="observer" v-slot="{ handleSubmit }">

    <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
      <b-row align-h="center">

        <b-col cols="4">
        <validation-provider name="email" rules="required|email" v-slot="validationContext">
          <!--<b-form-group id="email_group1" label="E-mail" label-for="email_input1">-->
            <b-form-input placeholder="E-mail Address" id="email_input1" name="email_input1" v-model="form.email" :state="getValidationState(validationContext)" aria-describedby="email_feedback">
            </b-form-input>
            <b-form-invalid-feedback id="email_feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          <!--</b-form-group>-->
        </validation-provider>
        </b-col>
      </b-row>

      <br />

      <b-button squared class="btn-welcome" type="submit">Submit</b-button>
    </b-form>

  </validation-observer>

</b-container>

  </div>
</template>





<script>
// @ is an alias to /src
import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate";

import en from "vee-validate/dist/locale/en.json";
import * as rules from "vee-validate/dist/rules";

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize("en", en);


export default {
  name: 'registerCheck',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      form: {
        email: null
      }
    };
  },

  mounted() {
    this.$store.state.loadingOverlay = false
  },

  methods: {

    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },

    onSubmit() {
      this.$store.state.loadingOverlay = true

      const axios = require('axios')
      var url = this.$store.state.locals.apiUrl + '/isUserWhitelisted'

      var email = this.form.email.toLowerCase()
      var data = JSON.stringify({
        email: email
      });

      var config = {
        method: 'post',
        url: url,
        headers: { 
          'api-key': this.$apikey, 
          'Content-Type': 'application/json'
        },
        data : data
      };

      axios(config)
      .then((response) => {
        var whitelist = response.data.whitelist

        // user is whitelsited
        if (whitelist == true) {
          this.$store.state.register.email = this.form.email.toLowerCase()
          this.$router.push('registerAllowed')

        // user is whitelisted, but already registered
        } else if (whitelist == "used") {
          this.$router.push('registeredAlready')

        // user is not whitelisted
        } else {
          this.$router.push('registerNotAllowed')
        }

      })
      .catch((error) => {
        console.log(error);
        this.$store.state.error = error;
        this.$router.push('error')
        //console.log(error.response.data);
      });

    }
  }
};
</script>
